import type { BuiltinConnectorDefinition } from '#layers/data-model/types/data-connectors/define';
import { dataConnectorDefinitions } from '#layers/data-model/data-connectors';

const mappedConnectors: Record<string, BuiltinConnectorDefinition<any, any>> = Object.fromEntries(
	dataConnectorDefinitions.map((connector) => [connector.id, connector]),
);

export default mappedConnectors;
